import React from "react";
import PropTypes from "prop-types";
import { SearchInput, Flex } from "@evertrue/et-components";
import classNames from "classnames";

// Used to keep consistent styles - used in 4 places in chat

const ChatActionBar = ({
  searchText,
  setSearchText,
  children,
  debounceTimeout = 0,
  placeholder,
  className,
  focusOnMount,
}) => {
  return (
    <Flex className={classNames("chat-action-bar", className)}>
      <SearchInput
        placeholder={placeholder}
        className="chat-action--search-box"
        value={searchText}
        onChange={setSearchText}
        debounceTimeout={debounceTimeout}
        focusOnMount={focusOnMount}
      />
      {children}
    </Flex>
  );
};

ChatActionBar.propTypes = {
  children: PropTypes.any,
  searchText: PropTypes.string,
  setSearchText: PropTypes.func,
  debounceTimeout: PropTypes.number,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  focusOnMount: PropTypes.bool,
};

export default ChatActionBar;
